import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
//Components
import { IsNullOrEmpty } from "utils/StringNullOrEmpty";
import { Visibility } from "components/Visibility";
import HeaderIndicator from "../HeaderIndicador";
import { LastHitsArea } from "./styles";
// services
import QuoteService from 'services/quote.service';
//Others
import { BudgetsSaved, ILastHits } from "./interface";
import { RootState } from "store/ducks";
import Parse from 'html-react-parser';

export const LastHits: React.FC<ILastHits> = (props) => {
  const { quoteId } = props;

  const dispatch = useDispatch();
  const updateBudgetSaved = useSelector((state: RootState) => state.updateBudgetSaved);
  const savedBudgets = useSelector((state: RootState) => state.savedBudgets) ?? [];
  const budgets = useSelector((state: RootState) => state.budgets);

  const _quoteService = new QuoteService();

  const getAllBudgetsSaved = async () => {
    const response = await _quoteService.budgetsSavedInQuote(quoteId, budgets?.sent!);

    if (response) {
      dispatch({ type: 'SET_ALL_BUDGETS_SAVED', data: response.data.data });
    }
  };

  useEffect(() => {
    if (!IsNullOrEmpty(budgets?.sent))
      getAllBudgetsSaved();
  }, [updateBudgetSaved?.isUpdate, budgets?.sent]);

  return (
    <Visibility visible={savedBudgets.length > 0}>
      <LastHitsArea>
        {savedBudgets.map((budget: BudgetsSaved, index: number) => (
          <HeaderIndicator
            key={budget.name}
            title={`Itens salvos: ${budget.quantity}`}
            information={Parse(`<span><b style="color:#287C87">Por:</b> ${budget.name}</span>`)}
            indicatorColor={"#287C87"}
          />
        ))}
      </LastHitsArea>
    </Visibility>
  );
};